import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {delay, Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';
import {MockDataService} from '@core-app/services/mocking/mock-data.service';
import {APP_CONFIG} from '@gallaghercp/core-frontend';

@Injectable()
export class MockDataInterceptor implements HttpInterceptor {

    constructor(
        private mockDataService: MockDataService
    ) {
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (APP_CONFIG.testMode) {
            const mockData = this.mockDataService.getMockData(request);
            if (mockData) {
                return of(new HttpResponse({status: 200, body: mockData})).pipe(
                    delay(Math.floor(Math.random()) + 200),
                );
            }
        }
        return next.handle(request);
    }

}
